import React from "react";
import types from "./types";

const Template = ({ variant, size, color, ...props }) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {variant === "outline" && (
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM9.71 19.667C8.72341 17.5743 8.15187 15.3102 8.027 13H4.062C4.25659 14.5389 4.89392 15.9882 5.89657 17.1717C6.89922 18.3552 8.22401 19.2221 9.71 19.667V19.667ZM10.03 13C10.181 15.439 10.878 17.73 12 19.752C13.1523 17.6766 13.8254 15.3695 13.97 13H10.03V13ZM19.938 13H15.973C15.8481 15.3102 15.2766 17.5743 14.29 19.667C15.776 19.2221 17.1008 18.3552 18.1034 17.1717C19.1061 15.9882 19.7434 14.5389 19.938 13V13ZM4.062 11H8.027C8.15187 8.68979 8.72341 6.42569 9.71 4.333C8.22401 4.77788 6.89922 5.64475 5.89657 6.8283C4.89392 8.01184 4.25659 9.4611 4.062 11V11ZM10.031 11H13.969C13.8248 8.6306 13.152 6.32353 12 4.248C10.8477 6.32345 10.1746 8.63052 10.03 11H10.031ZM14.29 4.333C15.2766 6.42569 15.8481 8.68979 15.973 11H19.938C19.7434 9.4611 19.1061 8.01184 18.1034 6.8283C17.1008 5.64475 15.776 4.77788 14.29 4.333V4.333Z"
        fill={color}
      />
    )}

    {variant === "default" && (
      <path
        d="M2.05005 13.0001H7.52705C7.69817 16.167 8.7076 19.2315 10.452 21.8801C8.26698 21.5369 6.25725 20.4793 4.73707 18.8726C3.21689 17.2659 2.27197 15.2008 2.05005 13.0001ZM2.05005 11.0001C2.27197 8.79942 3.21689 6.73429 4.73707 5.12763C6.25725 3.52097 8.26698 2.46334 10.452 2.12012C8.7076 4.76873 7.69817 7.83326 7.52705 11.0001H2.05005ZM21.9501 11.0001H16.473C16.3019 7.83326 15.2925 4.76873 13.548 2.12012C15.7331 2.46334 17.7429 3.52097 19.263 5.12763C20.7832 6.73429 21.7281 8.79942 21.9501 11.0001ZM21.9501 13.0001C21.7281 15.2008 20.7832 17.2659 19.263 18.8726C17.7429 20.4793 15.7331 21.5369 13.548 21.8801C15.2925 19.2315 16.3019 16.167 16.473 13.0001H21.951H21.9501ZM9.53005 13.0001H14.47C14.3055 15.6996 13.4553 18.3126 12 20.5921C10.5447 18.3126 9.69464 15.6996 9.53005 13.0001ZM9.53005 11.0001C9.69464 8.30063 10.5447 5.68768 12 3.40812C13.4553 5.68768 14.3055 8.30063 14.47 11.0001H9.53005Z"
        fill={color}
      />
    )}
  </svg>
);

Template.propTypes = types.propTypes;
Template.defaultProps = types.defaultProps;

export default Template;
